import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SiqError } from 'app/core/models/siq-error.model';

@Component({
  selector: 'siq-js-alert-overlay',
  templateUrl: './alert-overlay.component.html',
  styleUrls: ['./alert-overlay.component.scss']
})
export class AlertOverlayComponent implements OnInit {

  @Input() reportActivityName: string;
  @Input() menuItems: string[];
  @Output() clickEvent: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

}
